import { faLock, faUnlockAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap';
import classNames from 'classnames';

const Lock = ({ isLocked, onClick, size = 'md', className = 'text-dark' }) => (
    <>
        <FontAwesomeIcon
            id="lock"
            className={classNames('pop-hover', className)}
            icon={isLocked ? faLock : faUnlockAlt}
            onClick={onClick}
            size={size}
        />
        <UncontrolledTooltip target="lock">
            {isLocked ? 'Enable' : 'Lock'}&nbsp;Editing
        </UncontrolledTooltip>
    </>
);

export default Lock;
